import React, { useState, useEffect } from 'react';
import { object, bool } from 'prop-types';
import { TableCustom, Loading, MessageModal } from '../../common';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest } from '../../../utils/apiweb';
import { APIS } from '../../../config/apis';
import EmisionPlanPagoGrid from '../EmisionPlanPagoGrid';
import { getFormatNumber, precisionRound, getDateToString } from '../../../utils/convert';
import CuentaPlanPagoModal from '../CuentaPlanPagoModal';
import { useAccess } from '../../hooks/useAccess';
import { isNull } from '../../../utils/validator';
import { PERMISSIONS } from '../../../consts/permissions';
import { PLAN_PAGO_CUOTA_STATE } from '../../../consts/planPagoCuotaState';


const CuentaPlanesPagosGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        list: [],
        loading: false,
        showMessage: false,
        showMessageReactivacion: false,
        showFormGrid: false,
        showFormModal: false,
        rowId: 0
    });

    const mount = () => {
        if(props.data.idCuenta > 0) {
            setState(prevState => {
                return {...prevState,
                    idCuenta: props.data.idCuenta
                };
            });

            SearchPlanesPagos(props.data.idCuenta);
        }
    }
    useEffect(mount, [props.data.idCuenta]);

    const [accessPlanPagoReactivacionEdit, setAccessPlanPagoReactivacionEdit] = useState(false);
    const [accessPlanPagoAnulacionEdit, setAccessPlanPagoAnulacionEdit] = useState(false);
    const [access, readyAceess] = useAccess({
        key: '_SecurityAccesses',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });
    useEffect(() => {
        if (readyAceess) {
            const plan_pago_reactivacion_edit = access.some(f => f.codigo === PERMISSIONS.PLAN_PAGO_REACTIVACION_EDIT);
            setAccessPlanPagoReactivacionEdit(plan_pago_reactivacion_edit);
            const plan_pago_anulacion_edit = access.some(f => f.codigo === PERMISSIONS.PLAN_PAGO_ANULACION_EDIT);
            setAccessPlanPagoAnulacionEdit(plan_pago_anulacion_edit);
        }
    }, [readyAceess]);

    const getDescEstado = (row) => {
        if (isNull(row)) return "";
        else if (row.cancelado) return "Cancelado";
        else if (row.pagado) return "Pago completo";
        else return "Vigente";
    };

    const getImporteTotal = (row) => {
        return precisionRound(row.importePlanPago+row.importeSellados);
    }

    const cellVMR = (data) =>  <div className='action'>
                                    <div onClick={ (event) => handleClickView(data.value) } className="link">
                                    <span className="material-symbols-outlined" title="Ver">search</span>
                                    </div>
                                    {!props.disabled && !data.row.original.cancelado &&
                                    <div onClick={ (event) => handleClickPrint(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Reimprimir">print</span>
                                    </div>
                                    }
                                    {!props.disabled && accessPlanPagoAnulacionEdit && !data.row.original.cancelado && !data.row.original.pagado &&
                                    <div onClick={ (event) => handleClickRemove(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="cancelar">delete</span>
                                    </div>
                                    }
                                    {!props.disabled && accessPlanPagoReactivacionEdit && data.row.original.cancelado &&
                                    <div onClick={ (event) => handleClickReactivacion(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Reactivar">refresh</span>
                                    </div>
                                    }
                                </div>

    const tableColumns = [
        { Header: 'Número', accessor: 'numero', width: '8%', alignCell: 'right' },
        { Header: 'Código', accessor: 'codigo', width: '8%', alignCell: 'right' },
        { Header: 'Descripción', accessor: 'descripcion', width: '21%' },
        { Header: 'Fecha de generación', Cell: (props) => (props.value) ? getDateToString(props.value, true) : '', accessor: 'fechaRegistro', width: '16%' },
        { Header: 'Estado', Cell: (props) => getDescEstado(props.row.original), id: 'estado', accessor: 'id', width: '11%' },
        { Header: 'Importe total', Cell: (props) => getFormatNumber(getImporteTotal(props.row.original), 2), accessor: 'importePlanPago', width: '11%', alignCell: 'right' },
        { Header: () => <span title="Deuda judicializada">Deuda judicializada</span>, csvHeader: 'Deuda judicializada', Cell: (props) => props.row.original.tieneDeudaLegal ? 'Sí' : 'No', id: 'legalizada', accessor: 'tieneDeudaLegal', width: '16%' },
        { Header: '', Cell: cellVMR, id:'abm', accessor: 'id', width: '9%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickView = (id) => {
        setState(prevState => {
            return {...prevState, showFormModal: true, rowId: parseInt(id)};
        });
    }
    const handleClickPrint = (id) => {
        setState(prevState => {
            return {...prevState, showFormGrid: true, rowId: parseInt(id)};
        });
    }
    const handleClickRemove = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showMessage: true, rowId: parseInt(id)};
        });
    }
    const handleClickReactivacion = (id) => {
        setState(prevState => {
          return {...prevState, showMessageReactivacion: true, rowId: parseInt(id)};
        });
    }

    // funciones
    function SearchPlanesPagos(idCuenta) {
        setState(prevState => {
        return {...prevState, loading: true};
        });

        const paramsUrl = `/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PLAN_PAGO,
            paramsUrl,
            null,
            callbackSuccessPlanesPagos,
            callbackNoSuccess,
            callbackError
        );
    }
    function RemovePlanPago(idPlanPago) {
        setState(prevState => {
        return {...prevState, loading: true};
        });

        const paramsUrl = `/${idPlanPago}/caducidad`;

        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.PLAN_PAGO,
            paramsUrl,
            null,
            callbackRemovePlanPago,
            callbackNoSuccess,
            callbackError
        );
    }
    function ReactivatePlanPago(idPlanPago) {
        setState(prevState => {
        return {...prevState, loading: true};
        });

        const paramsUrl = `/${idPlanPago}/reactivacion`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PLAN_PAGO,
            paramsUrl,
            null,
            callbackReactivatePlanPago,
            callbackNoSuccess,
            callbackError
        );
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessPlanesPagos = (response) => {
        response.json()
        .then((data) => {
            data.forEach(row => row.cancelado = row.planPagoCuotas.some(f => f.idEstadoPlanPagoCuota === PLAN_PAGO_CUOTA_STATE.CANCELADO));
            data.forEach(row => row.pagado = row.planPagoCuotas.every(f => [PLAN_PAGO_CUOTA_STATE.PAGADO, PLAN_PAGO_CUOTA_STATE.COMPENSADO].includes(f.idEstadoPlanPagoCuota)));
            setState(prevState => {
                return {...prevState, loading: false, list: data};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };
    const callbackRemovePlanPago = (response) => {
        response.json()
        .then((response) => {
            SearchPlanesPagos(state.idCuenta);
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "El plan de pago fue cancelado correctamente");
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };
    const callbackReactivatePlanPago = (response) => {
        response.json()
        .then((response) => {
            SearchPlanesPagos(state.idCuenta);
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "El plan de pago fue reactivado correctamente");
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };


    return (
    <>
        <Loading visible={state.loading}></Loading>

        {state.showMessage && 
            <MessageModal
                title={"Confirmación"}
                message={"¿Está seguro de cancelar el plan de pago?"}
                onDismiss={() => {
                setState(prevState => {
                        return {...prevState, showMessage: false, rowId: 0};
                    });
                }}
                onConfirm={() => {
                    const idPlanPago = state.rowId;
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowId: 0};
                    });
                    RemovePlanPago(idPlanPago);
                }}
            />
        }

        {state.showMessageReactivacion &&
            <MessageModal
                title={"Confirmación"}
                message={"¿Está seguro de reactivar el plan de pago?"}
                onDismiss={() => {
                setState(prevState => {
                        return {...prevState, showMessageReactivacion: false, rowId: 0};
                    });
                }}
                onConfirm={() => {
                    const idPlanPago = state.rowId;
                    setState(prevState => {
                        return {...prevState, showMessageReactivacion: false, rowId: 0};
                    });
                    ReactivatePlanPago(idPlanPago);
                }}
            />
        }

        {state.showFormGrid && 
            <EmisionPlanPagoGrid
                idPlanPago={state.rowId}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showFormGrid: false, rowId: 0};
                    });
                }}
            />
        }
        {state.showFormModal && 
            <CuentaPlanPagoModal
                idPlanPago={state.rowId}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showFormModal: false, rowId: 0};
                    });
                }}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={ state.list }
        />
    </>
    );
}

CuentaPlanesPagosGrid.propTypes = {
    disabled: bool,
    data: object.isRequired,
};

CuentaPlanesPagosGrid.defaultProps = {
    disabled: false
};

export default CuentaPlanesPagosGrid;